import { render, staticRenderFns } from "./RecordForm.vue?vue&type=template&id=a77d5dec&scoped=true"
import script from "./RecordForm.vue?vue&type=script&lang=js"
export * from "./RecordForm.vue?vue&type=script&lang=js"
import style0 from "./RecordForm.vue?vue&type=style&index=0&id=a77d5dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77d5dec",
  null
  
)

export default component.exports